"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import NetworkServicesTabs from "@/components/pageTabs/networkServicesTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import AdvantageComp from "./components/advantages";
import ComparisonComp from "./components/comparison";
import ServiceByOneMind from "./components/serviceByOneMind";
import Solutions from "./components/solutions";

const NocSocHelpdeskPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <NetworkServicesTabs />
        <Box>
          <Intro />
          <AdvantageComp />
        </Box>
        <ServiceByOneMind />
      </PageLayout>
      <ComparisonComp />
      <PageLayout showContactForm>
        <Solutions />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default NocSocHelpdeskPage;
